module.exports = __webpack_public_path__ + "img/money12.eab7befd.png";